import React, { FC } from 'react'

import { Card } from 'src/components/atoms'
import { InternalUserDetailBasicInfo } from 'src/components/organisms'

import { InternalUserDetailEntity } from 'src/types'

type Props = {
  user: InternalUserDetailEntity
  className?: string
}

export const InternalUserDetailBasicInfoCard: FC<Props> = ({ user, className }) => {
  return (
    <div className={className}>
      <Card padding="--s1">
        <InternalUserDetailBasicInfo user={user} />
      </Card>
    </div>
  )
}
